const PREFIX = "@@weezevent/routes";

export const ACTIVITY = `${PREFIX}/ACTIVITY`;
export const BLOCK_TAG = `${PREFIX}/BLOCK_TAG`;
export const CANCEL_REFUND_CONFIRM = `${PREFIX}/CANCEL_REFUND_CONFIRM`;
export const CART = `${PREFIX}/CART`;
export const CART_CUSTOMER_FORM = `${PREFIX}/CART_CUSTOMER_FORM`;
export const CART_FORM = `${PREFIX}/CART_FORM`;
export const CART_INFORMATION = `${PREFIX}/CART_INFORMATION`;
export const CART_PAYMENT = `${PREFIX}/CART_PAYMENT`;
export const CART_WALLET_SELECTION = `${PREFIX}/CART_WALLET_SELECTION`;
export const DONATION = `${PREFIX}/DONATION`;
export const FAST_TOP_UP = `${PREFIX}/FAST_TOP_UP`;
export const FAST_TOP_UP_CONFIRMATION = `${PREFIX}/FAST_TOP_UP_CONFIRMATION`;
export const HOME = `${PREFIX}/HOME`;
export const LOGIN = `${PREFIX}/LOGIN`;
export const LOGIN_AKAMAI_CALLBACK = `${PREFIX}/LOGIN_AKAMAI_CALLBACK`;
export const LOGIN_CAS_CALLBACK = `${PREFIX}/LOGIN_CAS_CALLBACK`;
export const LOGIN_REACH_FIVE_CALLBACK = `${PREFIX}/LOGIN_REACH_FIVE_CALLBACK`;
export const LOGOUT_REACH_FIVE_CALLBACK = `${PREFIX}/LOGOUT_REACH_FIVE_CALLBACK`;
export const MOBILE_PAYMENT = `${PREFIX}/MOBILE_PAYMENT`;
export const ORDER = `${PREFIX}/ORDER`;
export const ORDER_CONFIRMATION = `${PREFIX}/ORDER_CONFIRMATION`;
export const ORDER_INVOICE_FORM = `${PREFIX}/ORDER_INVOICE_FORM`;
export const ORDER_SUMMARY = `${PREFIX}/ORDER_SUMMARY`;
export const ORDERS = `${PREFIX}/ORDERS`;
export const PASSWORD_RESET = `${PREFIX}/PASSWORD_RESET`;
export const PASSWORD_RESET_CONFIRM = `${PREFIX}/PASSWORD_RESET_CONFIRM`;
export const PAYMENT = `${PREFIX}/PAYMENT`;
export const PERSONAL_INFO = `${PREFIX}/PERSONAL_INFO`;
export const REFUND = `${PREFIX}/REFUND`;
export const SHOP = `${PREFIX}/SHOP`;
export const SHOP_MENU_EDIT = `${PREFIX}/SHOP_MENU_EDIT`;
export const SHOPS = `${PREFIX}/SHOPS`;
export const SHOP_PRODUCT = `${PREFIX}/SHOP_PRODUCT`;
export const SIGN_UP = `${PREFIX}/SIGN_UP`;
export const TOP_UP = `${PREFIX}/TOP_UP`;
export const TOP_UP_CONFIRMATION = `${PREFIX}/TOP_UP_CONFIRMATION`;
export const WALLET_CREATE = `${PREFIX}/WALLET_CREATE`;
export const WALLET_TICKET = `${PREFIX}/WALLET_TICKET`;
export const WALLET_UPDATE = `${PREFIX}/WALLET_UPDATE`;
